import React from "react";
import { css } from "@emotion/react";
import { atLeastMediaQuery, BREAKPOINTS, CSS_MQ } from "../../../styles/breakpoints";
import { CSS_COLORS, gutterSize } from "../../../styles/styles-css-variables";

export const StepNavigationBarWrapper: React.FC<React.PropsWithChildren> = props => {
  const styles = css`
    display: flex;
    justify-content: space-between;
    height: var(--bar-height);

    .full-width & {
      width: 100%;
      max-width: var(--max-content-width-new);

      margin-left: auto;
      margin-right: auto;

      padding-left: 0;
      padding-right: 0;
    }

    .content-width & {
      background-color: ${CSS_COLORS.GreenWhite};

      margin-left: calc(-1 * var(--container-gutter-size));
      margin-right: calc(-1 * var(--container-gutter-size));
      width: calc(100% + 2 * var(--container-gutter-size));

      ${atLeastMediaQuery(BREAKPOINTS.atLeastXl + 2 * gutterSize)} {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
      }

      padding-left: var(--container-gutter-size);
      padding-right: var(--container-gutter-size);
    }
  `;

  const wrapperStyles = css`
    height: var(--bar-height);

    .full-width & {
      //padding-left: var(--container-gutter-size);
      //padding-right: var(--container-gutter-size);

      background-color: ${CSS_COLORS.GreenWhite};
      width: 100%;
    }

    .content-width & {
      width: var(--max-content-width-new);
      margin: 0 auto;
    }
  `;

  return (
    <div css={wrapperStyles}>
      <div css={styles}>{props.children}</div>
    </div>
  );
};
